/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    LookupKeyEnum,
    LookupKeyEnumFromJSON,
    LookupKeyEnumFromJSONTyped,
    LookupKeyEnumToJSON,
} from './LookupKeyEnum';

/**
 * 
 * @export
 * @interface CreateCampaignLinkDto
 */
export interface CreateCampaignLinkDto {
    /**
     * 
     * @type {string}
     * @memberof CreateCampaignLinkDto
     */
    slug: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCampaignLinkDto
     */
    name: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateCampaignLinkDto
     */
    isActive: boolean;
    /**
     * 
     * @type {Date}
     * @memberof CreateCampaignLinkDto
     */
    validFrom: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof CreateCampaignLinkDto
     */
    validTo: Date | null;
    /**
     * 
     * @type {string}
     * @memberof CreateCampaignLinkDto
     */
    affiliateCode: string | null;
    /**
     * 
     * @type {number}
     * @memberof CreateCampaignLinkDto
     */
    trialDays: number | null;
    /**
     * 
     * @type {string}
     * @memberof CreateCampaignLinkDto
     */
    couponId: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateCampaignLinkDto
     */
    firstPurchaseOnly: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateCampaignLinkDto
     */
    allowPaymentWithoutCreditCard: boolean;
    /**
     * 
     * @type {LookupKeyEnum}
     * @memberof CreateCampaignLinkDto
     */
    preferredLookupKey: LookupKeyEnum | null;
    /**
     * 
     * @type {Array<LookupKeyEnum>}
     * @memberof CreateCampaignLinkDto
     */
    allowedLookupKeys: Array<LookupKeyEnum>;
}

export function CreateCampaignLinkDtoFromJSON(json: any): CreateCampaignLinkDto {
    return CreateCampaignLinkDtoFromJSONTyped(json, false);
}

export function CreateCampaignLinkDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateCampaignLinkDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'slug': json['slug'],
        'name': json['name'],
        'isActive': json['isActive'],
        'validFrom': (json['validFrom'] === null ? null : new Date(json['validFrom'])),
        'validTo': (json['validTo'] === null ? null : new Date(json['validTo'])),
        'affiliateCode': json['affiliateCode'],
        'trialDays': json['trialDays'],
        'couponId': json['couponId'],
        'firstPurchaseOnly': json['firstPurchaseOnly'],
        'allowPaymentWithoutCreditCard': json['allowPaymentWithoutCreditCard'],
        'preferredLookupKey': LookupKeyEnumFromJSON(json['preferredLookupKey']),
        'allowedLookupKeys': ((json['allowedLookupKeys'] as Array<any>).map(LookupKeyEnumFromJSON)),
    };
}

export function CreateCampaignLinkDtoToJSON(value?: CreateCampaignLinkDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'slug': value.slug,
        'name': value.name,
        'isActive': value.isActive,
        'validFrom': (value.validFrom === null ? null : value.validFrom.toISOString()),
        'validTo': (value.validTo === null ? null : value.validTo.toISOString()),
        'affiliateCode': value.affiliateCode,
        'trialDays': value.trialDays,
        'couponId': value.couponId,
        'firstPurchaseOnly': value.firstPurchaseOnly,
        'allowPaymentWithoutCreditCard': value.allowPaymentWithoutCreditCard,
        'preferredLookupKey': LookupKeyEnumToJSON(value.preferredLookupKey),
        'allowedLookupKeys': ((value.allowedLookupKeys as Array<any>).map(LookupKeyEnumToJSON)),
    };
}

